import React from 'react';

export default () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_6010_27150)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.4586 7.30366C17.7767 4.98708 15.7618 3.2916 13.3387 3.03374L13.1649 1.98988C13.0697 1.41868 12.5756 1 11.9965 1C11.4205 1 10.928 1.41431 10.8295 1.98178L10.6465 3.03533C8.09786 3.31289 6.00346 5.18127 5.44181 7.68836C5.37879 7.9697 5.33779 8.29769 5.25579 8.95367L4 19H4.16309L18.4586 7.30366ZM6.05914 19H20L18.7442 8.95367C18.7306 8.84455 18.7181 8.7445 18.7064 8.65224L6.05914 19ZM10.2676 20C10.0974 20.2942 10 20.6357 10 21C10 22.1046 10.8954 23 12 23C13.1046 23 14 22.1046 14 21C14 20.6357 13.9026 20.2942 13.7324 20H10.2676Z"
                fill="#E43F3F"
                fillOpacity="0.2"
            />
            <path
                d="M21.5 4.30957L2.5 19.6905"
                stroke="#E43F3F"
                strokeLinecap="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_6010_27150">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);
